import { render, staticRenderFns } from "./detail-signature.vue?vue&type=template&id=1cb4d004&"
import script from "./detail-signature.vue?vue&type=script&lang=js&"
export * from "./detail-signature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports